<script>
import { useNow } from '@vueuse/core';
import { formatDistance } from 'date-fns';
import { es } from 'date-fns/locale';
import emitter from '../../utils/emitter.js';

export default {
  setup() {
    return {
      now: useNow({ interval: 2_000 }),
    };
  },
  data() {
    return {
      saving: false,
      lastAutosavedAt: null,
      open: true,
    };
  },
  computed: {
    sections() {
      return this.$store.state.form.sections;
    },
    currentSectionName() {
      return this.$store.getters.currentSection?.name;
    },
    autosavedRelative() {
      if (!this.lastAutosavedAt) return '';
      if (this.lastAutosavedAt >= this.now) return 'hace un momento';

      return formatDistance(this.lastAutosavedAt, this.now, {
        addSuffix: true,
        locale: es,
        includeSeconds: true,
      });
    },
  },
  mounted() {
    emitter.on('form-saving', this.handleFormSaving);
    emitter.on('form-autosaved', this.handleFormAutosaved);
  },
  beforeUnmount() {
    emitter.off('form-saving', this.handleFormSaving);
    emitter.off('form-autosaved', this.handleFormAutosaved);
  },
  methods: {
    handleFormSaving(isSaving) {
      this.saving = isSaving;
    },
    handleFormAutosaved() {
      this.lastAutosavedAt = new Date();
    },
    submit() {
      emitter.emit('submit');
    },
    valid(section) {
      return this.$store.getters.validSection(section);
    },
    emitScroll(sectionName) {
      emitter.emit('scroll-to', sectionName);
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center space-y-8 rounded-l-lg bg-pv-blue-900 py-4">
    <div class="flex w-full flex-col">
      <button
        v-for="section in sections"
        :key="`${section.name}`"
        class="border-l focus:outline-none"
        :class="section.name === currentSectionName ?
          'bg-pv-blue-700 border-pv-yellow' : 'hover:bg-pv-blue-800 border-transparent'"
        @click="emitScroll(section.name)"
      >
        <span class="flex flex-row items-center pr-4">
          <span class="whitespace-nowrap px-8 py-2 text-base font-medium capitalize">
            {{ section.name }}
          </span>
          <span
            v-if="valid(section)"
            class="ml-auto flex size-4 items-center justify-center rounded-full border border-pv-yellow bg-pv-yellow bg-opacity-40"
          >
            <inline-svg
              class="size-2.5 fill-current text-pv-yellow"
              :src="require('assets/images/icons/check.svg')"
            />
          </span>

        </span>
      </button>
    </div>
    <div class="flex flex-col items-center gap-1 px-4">
      <kalio-button
        label="Guardar avance"
        :loading="saving"
        size="small"
        class="mt-6 mb-2"
        @click="submit"
      />
      <p
        v-if="saving"
        class="max-w-[10rem] text-center text-xs text-pv-blue-gray-400"
      >
        Guardando…
      </p>
      <p
        v-else-if="lastAutosavedAt"
        class="max-w-[10rem] text-center text-xs text-pv-blue-gray-400"
      >
        Guardado {{ autosavedRelative }}
      </p>
    </div>
  </div>
</template>
